import { Id } from '@softline/core';

export interface LastUsed<T> {
  id: Id;
  object: T;
  timestamp: string;
}

export interface LastUsedList<T> {
  key: string;
  value: LastUsed<T>[];
}
